import { db } from './config';
import {
  collection, addDoc, getDocs, doc, updateDoc,
  query, orderBy, serverTimestamp,
} from 'firebase/firestore';

const COL = 'submissions';

/** Save a new setup form submission. Returns the new doc ID. */
export async function saveSubmission(data) {
  const ref = await addDoc(collection(db, COL), {
    ...data,
    status: 'new',
    submittedAt: serverTimestamp(),
  });
  return ref.id;
}

/** Fetch all submissions, newest first. */
export async function getSubmissions() {
  const snap = await getDocs(
    query(collection(db, COL), orderBy('submittedAt', 'desc'))
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

/** Update just the status field of a submission. */
export async function updateSubmissionStatus(id, status) {
  await updateDoc(doc(db, COL, id), { status });
}
